import styled, { css } from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

import FastImage from 'react-native-fast-image';
import { Platform } from 'react-native';

export const Wrapper = styled.View`
  margin: ${RFValue(12)}px 24px;
  margin-top: ${RFValue(6)}px;
  padding: ${RFValue(28)}px ${RFValue(24)}px;
  border-radius: ${RFValue(20)}px;
  align-items: center;
  background-color: ${({theme}) => theme.colors.background};
 
  border:1px solid ${({ theme}) => theme.colors.border2};

  ${({theme}) =>
    Platform.OS === 'ios'
      ? css`
          shadow-color: ${theme.colors.dark_shadow};
          shadow-offset: 0px 4px;
          shadow-opacity: 0.1;
          shadow-radius: 9px;
        `
      : css`
     
        `}

`;

export const Image = styled(FastImage)`
  width: ${RFValue(96)}px;
  height: ${RFValue(50)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const Title = styled.Text`
  text-align: center;
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.text_dark};
`;

export const Subtitle = styled.Text`
  margin-top: ${RFValue(4)}px;
  text-align: center;
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text_fixed};
`;

export const ButtonContainer = styled.View`
  align-self: center;
`;

